export default "<ng-template #toastTemplate>\n    <div>{{ message.text }}</div>\n</ng-template>"